var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"loading m-auto"}),_vm._v("\n    Se il caricamento prende troppo tempo, \n    "),_c('a',{attrs:{"href":"."}},[_vm._v("Ricarica la pagina")]),_vm._v(".\n  ")])
}]

export { render, staticRenderFns }